import DirectDebitSepaForm from './direct-debit-sepa-form';

export default DirectDebitSepaForm;
